export const baseCampVersion = import.meta.env.VITE_APP_VERSION || '0.0.0'
